import React, { useMemo } from 'react'
import { makeStyles, Link } from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import PetAlert from './PetAlert'
import { getDogIssues } from '../../services/helpers'
import { Check, ExitToApp, Remove } from '@material-ui/icons'
import { gray, purple } from '../../utils/colors'
import { green } from '@material-ui/core/colors'

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		gap: '.175rem'
	},
	linkStyle: {
		color: theme.palette.secondary.main,
		fontSize: '0.875rem',
		fontWeight: 600,
		lineHeight: '1.1875rem'
	},
	checkedIn: {
		fill: green[400],
		height: 16,
		strokeWidth: 3,
		stroke: green[400]
	},
	notCheckedIn: {
		fill: gray[700],
		height: 16,
		strokeWidth: 1,
		stroke: gray[700]
	}
}))

/**
 *
 * @param {{
 * pet: {
 *  _id: boolean,
 *  name: string,
 *  household_id: string,
 *  permanent_service_restrictions: string[],
 *  temporary_service_restrictions: string[],
 *  tags: string[],
 *  sex: string,
 *  birthday: string,
 *  vaccines: [{expiration_date: string, name: string, type: string, _id: string, valid: boolean}],
 * },
 * showIssues: boolean
 * showSex: boolean,
 * showStatus: boolean,
 * status:
 * }} props
 * @returns
 */
const PetNameLink = ({ pet, showSex = false, showIssues = false, showStatus = false, visit = {} }) => {
	if (!pet || !pet._id || !pet.household_id) {
		return <span>Unknown</span>
	}

	const classes = useStyles()

	const petAlerts = useMemo(() => {
		if (!pet || !showIssues) {
			return null
		}

		const issues = getDogIssues(pet, visit)

		return <PetAlert issues={issues} />
	}, [pet, showIssues])

	const statusIndicator = useMemo(() => {
		if (!showStatus) {
			return null
		}

		if (!pet.status) {
			return <Remove className={classes.notCheckedIn} />
		}

		const { status } = pet

		if (status.checked_in === true) {
			return <Check className={classes.checkedIn} />
		}

		if (status.checked_in === false) {
			return <ExitToApp className={classes.notCheckedIn} />
		}

		return null
	}, [pet, showStatus])

	return (
		<div className={classes.root}>
			{statusIndicator}
			<Link
				component={RouterLink}
				to={`/clients/${pet.household_id}/pets/${pet._id}`}
				className={classes.linkStyle}>
				{pet.name}
				{showSex && pet.sex
					? pet.sex == 'Intact Male' || pet.sex == 'Neutered Male'
						? ' (M)'
						: pet.sex == 'Intact Female' || pet.sex == 'Spayed Female'
						? ' (F)'
						: ''
					: ''}
			</Link>
			{petAlerts}
		</div>
	)
}

export default PetNameLink
